import requester from '@/utils/request'

interface ReportData {
  event: string
  extra: Record<string, any>
  page: string
  referrer: string
  timestamp: number
}

export const reportService = {
  // 上报埋点
  addTrack: (data: ReportData) => requester.post('/track/add', data),
  // 上报推广标签使用情况
  addPromotionTagUsage: (data: any) => requester.post('/shop/promotion-tag-usage/add-record', data),
}
